
<template>
  <div id="use-cases" class="container pb-4">
    <h2  class="section-title">{{ page_title }}</h2>
    <div>
      <ul class="use-case-list">
        <li v-for="(page,index) in pages" :key="page.sys.id + '_' + index" class="chevrons">
          <router-link :to="'/article/' + page.sys.id">
            <div class="use-case-name" >{{ page.fields.title }}</div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
 export default {
   name: 'use-cases',
   data() {
     return {
       page_title: 'Common Use Cases',
       pages: []
     }
   },
   methods: {
     getUseCases() {
       const query = {
         skip: 0,
         limit: 100,
         content_type: "use_case"
       };
       this.$contentful
           .getEntries(query)
           .then((res) => {
             console.log("got some articles")
             console.log(res.items)
             this.pages = res.items
           })
           .catch((error) => {
             console.error( 'ERROR: ' + error );
           })
     }
 },
   created() {
     this.getUseCases()
   }
 }
</script>

<style>
 li a {
     color: #002330;
 }

 ul {
     padding-left: 0;
 }

 ul.use-case-list {
     max-width: 28em;
 }

 .use-case-name {
     font-family: 'Titillium Web', sans-serif;
     font-size: 24px;
     font-weight: 600;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
 }

</style>
